module.exports = __webpack_public_path__ + "img/study_stacontent_icon1.5555fe80.png";